// extracted by mini-css-extract-plugin
export default {"wrapper":"gsAO9FrX","title":"_kMUKWOH","userCard":"puiY8Vq5","userCard__content":"wf1DmcTS","userCard__content__name":"ewDOhrEd","userCard__buttons":"wqK7gYpV","formElement":"_TyO186U"};
    if(module.hot) {
      // 1764331277771
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  